import { Checkbox } from "antd";
import { ErrorMessage, Field, Formik, Form } from "formik";
import React, { useState,useEffect } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { ProductOwnerLogin } from "../../Api/Login/AllLogin";
import { Navigate, useNavigate } from "react-router";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import Password from "antd/es/input/Password";
import { decryptData, encryptData } from "../Common/Encrypt-Decrypt";
 
const validationSchema = Yup.object().shape({
  emailid_phone: Yup.string()
    .required("Email or Phone is required")
    // .max(40, "Maximum 40 characters allowed")
    .test("validate-email-or-phone", function (value) {
      const { path, createError } = this;

      const isEmail = value?.includes("@");
      const onlyDigits = /^\d+$/.test(value);

      // ✅ EMAIL VALIDATION
      if (isEmail) {

        const emailRegex =
          /^[a-zA-Z0-9]+[a-zA-Z0-9._%]*[a-zA-Z0-9]@[a-zA-Z0-9]+(\.[a-zA-Z]{2,})+$/;

        // ❌ invalid email → show message
        if (!emailRegex.test(value)) {
          return createError({
            path,
            message: "Special characters are not allowed.",
          });
        }

        // duplicate domain parts → reject
        const domain = value.split("@")[1] || "";
        const tlds = domain.split(".");

        if (tlds.length >= 2 && tlds.at(-1) === tlds.at(-2)) {
          return createError({
            path,
            message: "Invalid domain format",
          });
        }

        return true; // VALID EMAIL
      }

      // ✅ PHONE VALIDATION
      if (onlyDigits) {
        if (value.length !== 10) {
          return createError({
            path,
            message: "Phone number must be 10 digits",
          });
        }

        if (!/^[6-9]/.test(value)) {
          return createError({
            path,
            message: "Phone number must start with 6, 7, 8, or 9",
          });
        }

        return true;
      }

      // ❌ NON-EMAIL + NON-PHONE
      return createError({
        path,
        message: "Enter a valid Email or Phone Number",
      });
    }),
    // password:Yup.string() .require("Password is required"),
});



export default function ProductOwner({ setAuthtoken, setForgotPassword,setLoading }) {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe,setRememberMe]=useState(false)
   const [emailid_phone, setEmail] = useState('');
  const [password, setPassword] = useState('');
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // const phoneRegex = /^\d{10}$/;


  

  const validateInput = (input) => {
    const emailRegex = /\S+@\S+\.\S+/;
    const phoneRegex = /^\d{10}$/;
    if (emailRegex.test(input)) {
      return 1; // Email
    } else if (phoneRegex.test(input)) {
      return 2; // Phone
    }
    return 0; // Invalid
  };

  // const handleSubmit = async (values, { setSubmitting, setAuthtoken }) => {
  //   const validationResult = validateInput(values.emailid_phone);

  //   try {
  //     const data = await ProductOwnerLogin(
  //       values,
  //       validationResult,
  //       setAuthtoken
  //     );
  //     toast.success(data?.message);
  //     console.log(data, "datadatadatadatadata");
  //     if (data?.token) {
  //       navigate("/dashboard");
  //       window.location.reload();
  //     }
  //   } catch (error) {
  //     toast.error(error.message);
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  const handleSubmit = async (
    values,
    { setSubmitting, setFieldError, setAuthtoken }
  ) => {
    const validationResult = validateInput(values.emailid_phone);
    setLoading(true)
    try {
      const data = await ProductOwnerLogin(
        values,
        validationResult,
        dispatch,
        setAuthtoken
      );
      const loginPassword=values.password
      const loginemail=values.emailid_phone

      // toast.success(data);
       console.log(data, "datadatadatadatadata");
      //  const expiryTime = Date.now() + 2 * 60 * 1000;
           if (rememberMe) {
      localStorage.setItem('email', encryptData(loginemail));
      localStorage.setItem('password',encryptData(loginPassword)); 
      localStorage.setItem('rememberme',rememberMe)
      // localStorage.setItem('expiry', expiryTime.toString());
    } else {
       localStorage.removeItem('email', values.emailid_phone);
      localStorage.removeItem('password',values.password); 
      localStorage.removeItem('rememberme',rememberMe)
      // localStorage.removeItem('expiry', expiryTime.toString());
    }
     

      if (data?.token) {
        navigate("/dashboard" );
        window.location.reload();
      } else {
        // if(data?.status===202) { 
        if(typeof data?.message === "string" && data.message.includes("No product owner found with provided email/phone"))  {
          setFieldError("emailid_phone","Invalid Email or Phone number")
        }
        // else if( data===null) { 
        else if(typeof data?.message === "string" && data.message.includes("Password incorrect"))  { 
          setFieldError("password","Invalid Password")
          }
        
      }
  //       if (!data?.token) {
  //   return <Navigate to="/dashboard" replace />;
  // }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setFieldError("password", " Invalid Email or Phone number");
        // toast.error("Invalid Password / Username");
      } else {
        toast.error(error.message);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
useEffect(() => {
  // const expiry = localStorage.getItem('expiry');
  // const now = Date.now();
  const remember = localStorage.getItem('rememberme');

  if (remember) {
    const email = localStorage.getItem('email');
    const password = localStorage.getItem('password');
    const remember = localStorage.getItem('rememberme');
    const emailId=decryptData(email)
    const Password=decryptData(password)
    if (emailId) setEmail(emailId);
    if (Password) setPassword(Password);
    if (remember) setRememberMe(remember);

  } else {
    localStorage.clear();
  }
}, []);
  
  return (
    <div className="absolute right-0 top-0 bg-[#E5FFF1] h-full w-[70vw] md:w-[38vw] rounded-tr-[2vw] rounded-br-[2vw] bg-opacity-80 flex flex-col items-center justify-center">
      <label className="text-[#1F487C] font-bold text-[5vw] md:text-[2vw] ">
        PRODUCT OWNER
      </label>
      <p className="text-[#1F487C] text-[3vw] md:text-[1vw] py-[2vw]">
        Welcome Back, Please sign in to your account
      </p>
      <Formik
      
        initialValues={{
          emailid_phone: emailid_phone,
          password: password,
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting, setFieldError, setAuthtoken }) => {
          handleSubmit(values, { setSubmitting, setFieldError, setAuthtoken });
        }}
      >
        {({ isSubmitting,handleChange }) => (
          <Form name="LoginCRM" autoComplete="off">
            <div className="gap-y-[1.5vw] flex-col flex">
              <div className="col-span-1 relative">
                <label className="text-[#1F487C] text-[3vw] md:text-[1.1vw] ">
                  Email / Phone
                  <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
                </label>
                <Field
                  type="text"
                  name="emailid_phone"
                  placeholder="Enter Email / Phone Number"
                  autoComplete="off"
                  onChange={(e) => {
                let inputValue = e.target.value;
                   inputValue=inputValue.replace(/\s+/g, "");
                handleChange({
                  target: { name: e.target.name, value: inputValue },
                });
              }}
                  className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[3vw] md:text-[1vw] h-[7.5vw] md:h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                />
                <ErrorMessage
                  name="emailid_phone"
                  component="div"
                  className="text-red-500 text-[2vw] md:text-[0.8vw] absolute bottom-[-3vw] md:bottom-[-1.2vw] font-semibold md:font-normal"
                />
              </div>
              <div className="col-span-1 ">
                <label className="text-[#1F487C] text-[3vw] md:text-[1.1vw] ">
                  Password
                  <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
                </label>
                <div className="relative flex items-center">
                  <Field
                    type={showPassword ? "text" : "password"}
                    maxLength={30}
                    name="password"
                    placeholder="Enter Password"
                   autoComplete="off"
                   onChange={(e) => {
                let inputValue = e.target.value;
                   inputValue=inputValue.replace(/\s+/g, "");
                handleChange({
                  target: { name: e.target.name, value: inputValue },
                });
              }}
                   
                    className="border-r-[0.3vw] mt-[0.5vw] pr-[3vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[3vw] md:text-[1vw] h-[7.5vw] md:h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                  />
                  <div
                    className="absolute right-[3vw] md:right-[1vw] cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      <FaEye className="text-[3.5vw] md:text-[1.5vw] text-[#1F487C]" />
                    ) : (
                      <FaEyeSlash className="text-[3.5vw] md:text-[1.5vw] text-[#1F487C]" />
                    )}
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-red-500 text-[2vw] md:text-[0.8vw] absolute bottom-[-3vw] md:bottom-[-1.2vw] font-semibold md:font-normal"
                  />
                </div>
              </div>
              <div className="flex justify-between items-center mt-[2.5vw] md:mt-0">
                <div className="flex justify-between items-baseline md:items-center gap-[1vw]">
                  {/* <Checkbox> */}
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={() =>setRememberMe(!rememberMe)}
                    className="h-[2.5vw] md:h-[.9vw] w-[2.5vw] md:w-[.9vw] cursor-pointer "
                  />
                  <span className="text-[#1F4B7F] text-[2.5vw] md:text-[1vw] ">
                    Remember me
                  </span>
                </div>
                <div>
                  <p
                    className="text-[#1F487C] text-[2.5vw] md:text-[1vw] cursor-pointer"
                    onClick={() => setForgotPassword(true)}
                  >
                    Forgot Password
                  </p>
                </div>
              </div>
              <div className="">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full flex justify-center py-[1vw] md:py-[0.5vw] px-4 border border-transparent rounded-md shadow-sm text-[3vw] md:text-[1.2vw] font-medium text-white bg-[#1F487C]"
                >
                  Sign In
                </button>
              </div>
              <p className="text-center text-[2vw] md:text-[0.8vw] text-[#1F487C]">
                CRM Version V-1.02
              </p>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
